import {
  Context,
  ContextValue,
  SortCriterion,
  SortOrder,
  buildCriterionExpression,
  buildFieldSortCriterion,
  buildRelevanceSortCriterion,
} from '@coveo/atomic-react';
import { CoveoSearchHub } from '@lib/coveo/coveoConstants';
import {
  FIELD_SORT_DATA,
  POPULARITY_CONTEXT_KEY,
  POPULARITY_SORT_VALUE,
  RATING_CONTEXT_KEY,
  RATING_SORT_VALUE,
  RELEVANCE_SORT_VALUE,
} from './sortCriteriaData';

export {
  POPULARITY_CONTEXT_KEY,
  RATING_CONTEXT_KEY,
  getSortValueForRankingContext,
} from './sortCriteriaData';

export const RELEVANCE_SORT = {
  value: RELEVANCE_SORT_VALUE,
  criterion: buildRelevanceSortCriterion(),
};
export const POPULARITY_SORT = {
  value: POPULARITY_SORT_VALUE,
  criterion: buildRelevanceSortCriterion(),
};
export const RATING_SORT = {
  value: RATING_SORT_VALUE,
  criterion: buildRelevanceSortCriterion(),
};

export const RELEVANCY_CRITERION_EXPRESSION = buildCriterionExpression(
  RELEVANCE_SORT.criterion
);

/**
 * Coveo types `ContextValue` as string-only, but the pipeline Conditions these
 * keys drive are boolean-typed and the Search API accepts booleans, so the
 * value has to be cast past the public type.
 */
const addBooleanContext = (context: Context, key: string, value: boolean) =>
  context.add(key, value as unknown as ContextValue);

/**
 * Writes both ranking-mode flags on every call so the two can never drift:
 * there is no path that sets one without clearing the other.
 */
export const applyRankingContext = (
  context: Context | undefined,
  sortValue: string
) => {
  if (!context) return;

  addBooleanContext(
    context,
    POPULARITY_CONTEXT_KEY,
    sortValue === POPULARITY_SORT.value
  );
  addBooleanContext(
    context,
    RATING_CONTEXT_KEY,
    sortValue === RATING_SORT.value
  );
};

export const getSortValueForCmsSortOrder = (
  name: string | null | undefined
): string => {
  switch (name) {
    case 'Popularity':
      return POPULARITY_SORT.value;
    case 'Rating':
      return RATING_SORT.value;
    default:
      return RELEVANCE_SORT.value;
  }
};

const FIELD_SORT_CRITERIA: { value: string; criterion: SortCriterion }[] =
  FIELD_SORT_DATA.map(({ value, field, order }) => ({
    value,
    criterion: buildFieldSortCriterion(
      field,
      order === 'ascending' ? SortOrder.Ascending : SortOrder.Descending
    ),
  }));

export const SEARCH_SORT_CRITERIA: {
  value: string;
  criterion: SortCriterion;
}[] = [RELEVANCE_SORT, POPULARITY_SORT, RATING_SORT, ...FIELD_SORT_CRITERIA];

export const LISTING_SORT_CRITERIA: {
  value: string;
  criterion: SortCriterion;
}[] = [POPULARITY_SORT, RATING_SORT, ...FIELD_SORT_CRITERIA];

export const getSortCriteriaForSearchHub = (searchHub: string | undefined) => {
  if (searchHub === CoveoSearchHub.SEARCH) {
    return SEARCH_SORT_CRITERIA;
  }
  return LISTING_SORT_CRITERIA;
};
